<div class="chat-transcript" #messageList (scroll)="onScroll()" role="log" aria-live="polite">
    @for (activity of visibleActivities; track trackByActivityId($index, activity)) {
        <div class="message-row" [class.from-user]="isUserMessage(activity)" [class.from-bot]="!isUserMessage(activity)">
            <div class="message-bubble">
                @if (activity.text) {
                    <div class="message-text scout-ai-markdown" [innerHTML]="activity.text | markdown"></div>
                }
                @if (hasOAuthCard(activity)) {
                    <div class="oauth-card">
                        <a [href]="getSignInUrl(activity)" target="_blank" rel="noopener noreferrer" class="sign-in-btn">
                            <i class="fa-solid fa-right-to-bracket"></i> Sign In
                        </a>
                    </div>
                }
                <div class="message-meta">
                    @if (activity.responseTimeSeconds) {
                        <span class="response-time">Answered in {{ activity.responseTimeSeconds }}s</span>
                    }
                    <span class="message-timestamp">{{ relativeTimeMap.get(activity.id) }}</span>
                </div>
            </div>
        </div>
    }

    @if (isWaitingForResponse) {
        <div class="message-row from-bot">
            <div class="thinking-dots">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    }

    @if (sessionEnded) {
        <div class="session-ended">
            <p>Session ended.</p>
            <button class="btn-new-conversation" (click)="onStartNewConversation()">Start New Conversation</button>
        </div>
    }
</div>

@if (suggestedActions.length > 0 && !sessionEnded) {
    <div class="suggested-actions">
        @for (action of suggestedActions; track trackByActionTitle($index, action)) {
            <button class="suggested-action-btn" (click)="onSuggestedActionClicked(action)">
                {{ action.title }}
            </button>
        }
    </div>
}

@if (!sessionEnded) {
    <div class="send-box">
        <div class="send-box-inner">
            <textarea [(ngModel)]="messageText"
                      name="messageText"
                      (keydown)="onKeyDown($event)"
                      placeholder="Type a message..."
                      rows="1"
                      class="send-input"
                      aria-label="Type a message"></textarea>
            <button (click)="onSend()"
                    [disabled]="!messageText.trim()"
                    class="send-btn"
                    aria-label="Send message">
                <i class="fa-solid fa-paper-plane"></i>
            </button>
        </div>
    </div>
}
